import styled from 'styled-components';

const Input = styled.input`
    padding-block: 12px;
    padding-left: 40px;
    padding-right: 18px;
    font-size: 14px;
    color: #FFFFFF;
    background: rgba(63, 65, 69, 0.34);
    border: 1px solid rgba(208, 213, 219, 0.34);
    border-radius: 58px;
    width: 100%;

    &:focus {
        outline: 0;
    }
`;

export default Input;